import { render, staticRenderFns } from "./TicketSolveTime.vue?vue&type=template&id=67b105bc&scoped=true"
import script from "./TicketSolveTime.vue?vue&type=script&lang=js"
export * from "./TicketSolveTime.vue?vue&type=script&lang=js"
import style0 from "./TicketSolveTime.vue?vue&type=style&index=0&id=67b105bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b105bc",
  null
  
)

export default component.exports